import PropTypes from 'prop-types';
import { useState } from 'react';

// material-ui
import { styled, useTheme } from '@mui/material/styles';
import { Box, Grid, Menu, MenuItem, Typography } from '@mui/material';

// project imports
import MainCard from 'ui-component/cards/MainCard';
import colors from 'assets/scss/_themes-vars.module.scss';

// ===========================|| DASHBOARD DEFAULT - EARNING CARD ||=========================== //

const Header = ({ ...props }) => {
    const CardWrapper = styled(MainCard)(({ theme }) => ({
        // background: 'linear-gradient(to left, rgba(230, 92, 0, 1), rgba(249, 212, 35, 0.8))',
        background: 'linear-gradient(to right, rgba(24,26,29, 0.8), rgba(18,19,21, 0.8))',
        color: '#fff',
        overflow: 'hidden',
        position: 'relative',
        paddingLeft: '0px',
        paddingRight: '0px',
        overflow: 'hidden',
        '&:after': {
            content: '""',
            position: 'absolute',
            background: props.background,
            backgroundPosition: props.backgroundPosition,
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundSize: 'cover',
            opacity: 0.5
        }
    }));

    return (
        <CardWrapper border={false} content={true}>
            <Box sx={{ pb: 1.25, pl: 0, pr: 0 }}>
                <Grid container direction="column">
                    <Grid item>
                        <Grid container alignItems="center">
                            <Grid item>
                                <Typography
                                    sx={{
                                        fontSize: '2.125rem',
                                        color: colors.white,
                                        fontWeight: 500,
                                        mr: 1,
                                        mt: 1.75,
                                        mb: 0.75,
                                        zIndex: 5,
                                        position: 'relative'
                                    }}
                                >
                                    {props.title}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item sx={{ mb: 1.25 }}>
                        <Typography
                            sx={{
                                fontSize: '1rem',
                                fontWeight: 500,
                                color: colors.white,
                                zIndex: 5,
                                position: 'relative'
                            }}
                        >
                            {props.subtitle}
                        </Typography>
                    </Grid>
                </Grid>
            </Box>
        </CardWrapper>
    );
};

export default Header;
